import label from "@/lang/StaticLabels.js";

// PBASE Router  - مدیریت سیستم  -----------------------------------------------
let routeItems = {
  path: "PBASE",
  name: "PBASE",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  redirect: "/PBASE/dashboard",
  children: [
    {
      path: "dashboard",
      name: "Dashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pbase,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/Dashboard"),
    },
    {
      path: "visitor",
      name: "PBASEVisitor",
      meta: {
        label: label.page.visitor,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/visitor"),
    },
    {
      path: "template",
      name: "Template",
      meta: {
        label: label.page.visitor,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/Template.vue"),
    },
    {
      path: "boardOfDirectors",
      name: "BoardOfDirectors",
      meta: {
        label: label.page.boardOfDirectors,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/management"),
    },
    {
      path: "usersGroup",
      name: "PBASEUsersGroup",
      meta: {
        label: label.page.usersGroup,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/usersGroup"),
    },
    {
      path: "prefix",
      name: "PBASEPrefix",
      meta: {
        label: label.page.prefix,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/prefix"),
    },
    {
      path: "lastLogin",
      name: "PBASELastLogin",
      meta: {
        label: label.page.activeSessions,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/lastLogin"),
    },
    {
      path: "smsPanelSettings",
      name: "PBASESmsPanelSettings",
      meta: {
        label: label.page.smsPanelSettings,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/setting"),
    },
    {
      path: "users",
      name: "PBASEUsers",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "users/list",
      children: [
        {
          path: "list",
          name: "PBASEUserList",
          component: () => import("@/views/modules/pbase/users"),
          meta: {
            label: label.page.usersAndRoles,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PBASEAddUser",
          component: () => import("@/views/modules/pbase/users/Add"),
          meta: {
            label: label.page.addUser,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBASEEditUser",
          component: () => import("@/views/modules/pbase/users/Edit"),
          meta: {
            label: label.page.updateUser,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "branch",
      name: "PBASEBranch",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "branch/list",
      children: [
        {
          path: "list",
          name: "PBASEBranchList",
          component: () => import("@/views/modules/pbase/branch"),
          meta: {
            label: label.page.branches,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PBASEAddBranch",
          component: () => import("@/views/modules/pbase/branch/Add"),
          meta: {
            label: label.page.addBranch,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBASEEditBranch",
          component: () => import("@/views/modules/pbase/branch/Edit"),
          meta: {
            label: label.page.editBranch,
            requiresAuth: true,
          },
        },
        {
          path: "taxSetting/:id",
          name: "PBASEBranchTaxSetting",
          component: () => import("@/views/modules/pbase/branch/TaxSetting"),
          meta: {
            label: label.page.branchTaxSetting,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "role",
      name: "PBASERoles",
      component: () => import("@/views/modules/pbase/role"),
      meta: {
        label: label.page.roles,
        requiresAuth: true,
      },
    },
    {
      path: "permission/:id?",
      name: "PBASERolePermissions",
      component: () => import("@/views/modules/pbase/role/Permission"),
      meta: {
        label: label.page.permissions,
        requiresAuth: true,
      },
    },
    {
      path: "fiscalYear",
      name: "PBASEFiscalYear",
      component: () => import("@/views/modules/pbase/fiscalYear"),
      meta: {
        label: label.page.fiscalYears,
        requiresAuth: true,
      },
    },
    {
      path: "location",
      name: "PBASELocation",
      meta: {
        label: label.page.location,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/location"),
    },
    {
      path: "systemSetting",
      name: "PBASESystemSetting",
      meta: {
        label: label.page.systemSetting,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/systemSetting"),
    },
    {
      path: "settingTransactions",
      name: "PBASESettingTransactions",
      meta: {
        label: label.page.settingTransactions,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pbase/transactionInfo/index.vue"),
    },
    {
      path: "voucherTemplate",
      name: "PBASEVoucherTemplate",
      meta: {
        label: label.page.voucherTemplate,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/voucherTemplate"),
    },
    {
      path: "personGroup",
      name: "PBASEPersonGroup",
      meta: {
        label: label.page.personGroup,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/personGroup"),
    },
    {
      path: "position",
      name: "PBASEPosition",
      meta: {
        label: label.page.position,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/position"),
    },
    {
      path: "banks&branches",
      name: "PBASEBankesAndBranches",
      meta: {
        label: label.page.banksAndBranches,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pbase/banksAndBranches/index.vue"),
    },
    {
      path: "currencyType",
      name: "PBASECurrencyType",
      meta: {
        label: label.page.currencyType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/currencyType"),
    },
    {
      path: "currencyRate",
      name: "PBASECurrencyRate",
      meta: {
        label: label.page.currencyRate,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/currencyRate"),
    },
    {
      path: "vehicleTypes",
      name: "PBASEVehicleTypes",
      meta: {
        label: label.page.vehicleTypes,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/vehicleTypes"),
    },
    {
      path: "unit",
      name: "PBASEUnit",
      meta: {
        label: label.page.unit,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/unit"),
    },

    {
      path: "person",
      name: "PBASEPerson",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "person/list",
      children: [
        {
          path: "list",
          name: "PBASEPersonList",
          component: () => import("@/views/modules/pbase/person"),
          meta: {
            label: label.page.person,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PBASEAddPerson",
          component: () => import("@/views/modules/pbase/person/add/index"),
          meta: {
            label: label.page.addPerson,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBASEEditPerson",
          component: () => import("@/views/modules/pbase/person/edit/index"),
          meta: {
            label: label.page.editPerson,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "sbu",
      name: "PBASESbu",
      meta: {
        label: label.page.manangeSbu,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/sbu"),
    },
    {
      path: "floatAccountConfig",
      name: "PBASEFloatAccountConfig",
      meta: {
        label: label.page.floatLevels,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pbase/floatAccountManagement/floatAccountConfig"
        ),
    },
    {
      path: "cartableConfirmPriority",
      name: "PBASECartableConfirmPriority",
      meta: {
        label: label.page.approvalCartablePriorities,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/cartable/ConfirmPriority"),
    },
    {
      path: "floatAccount",
      name: "PBASEFloatAccount",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "floatAccount/list",
      children: [
        {
          path: "list/one",
          name: "PBASEFloatAccountLevelOne",
          component: () =>
            import(
              "@/views/modules/pbase/floatAccountManagement/floatAccount/levelOne"
            ),
          meta: {
            label: label.menu.floatAccountManagement,
            requiresAuth: true,
          },
        },
        {
          path: "list/two",
          name: "PBASEFloatAccountLevelTwo",
          component: () =>
            import(
              "@/views/modules/pbase/floatAccountManagement/floatAccount/levelTwo"
            ),
          meta: {
            label: label.menu.floatAccountManagement,
            requiresAuth: true,
          },
        },
        {
          path: "list/three",
          name: "PBASEFloatAccountLevelThree",
          component: () =>
            import(
              "@/views/modules/pbase/floatAccountManagement/floatAccount/levelThree"
            ),
          meta: {
            label: label.menu.floatAccountManagement,
            requiresAuth: true,
          },
        },
        {
          path: "list/four",
          name: "PBASEFloatAccountLevelFour",
          component: () =>
            import(
              "@/views/modules/pbase/floatAccountManagement/floatAccount/levelFour"
            ),
          meta: {
            label: label.menu.floatAccountFour,
            requiresAuth: true,
          },
        },
        {
          path: "list/five",
          name: "PBASEFloatAccountLevelFive",
          component: () =>
            import(
              "@/views/modules/pbase/floatAccountManagement/floatAccount/levelFive"
            ),
          meta: {
            label: label.menu.floatAccountFive,
            requiresAuth: true,
          },
        },
      ],
    },

    {
      path: "floatAccountsGroup",
      name: "PBASEFloatAccountsGroup",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "floatAccountsGroup/list",
      children: [
        {
          path: "list/one",
          name: "PBASEFloatAccountGroupOne",
          component: () =>
            import("@/views/modules/pbase/floatAccountsGroup/GroupOne"),
          meta: {
            label: label.menu.floatAccountGroup,
            requiresAuth: true,
          },
        },
        {
          path: "list/two",
          name: "PBASEFloatAccountGroupTwo",
          component: () =>
            import("@/views/modules/pbase/floatAccountsGroup/GroupTwo"),
          meta: {
            label: label.menu.floatAccountGroup,
            requiresAuth: true,
          },
        },
        {
          path: "list/three",
          name: "PBASEFloatAccountGroupThree",
          component: () =>
            import("@/views/modules/pbase/floatAccountsGroup/GroupThree"),
          meta: {
            label: label.menu.floatAccountGroup,
            requiresAuth: true,
          },
        },
        // {
        //   path: "list/four",
        //   name: "PBASEFloatAccountGroupFour",
        //   component: () => import("@/views/modules/pbase/floatAccountsGroup/GroupFour"),
        //   meta: {
        //     label: label.menu.floatAccountGroup,
        //     requiresAuth: true,
        //   },
        // },
        // {
        //   path: "list/five",
        //   name: "PBASEFloatAccountGroupFive",
        //   component: () => import("@/views/modules/pbase/floatAccountsGroup/GroupFive"),
        //   meta: {
        //     label: label.menu.floatAccountGroup,
        //     requiresAuth: true,
        //   },
        // },
      ],
    },
    {
      path: "documentTypes",
      name: "PBASEDocumentTypes",
      meta: {
        label: label.page.documentTypes,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/documentTypes/index.vue"),
    },
  ],
};

export default routeItems;
